module.exports = __webpack_public_path__ + "static/basketball-f8beb2c02205a951d93ace1c81c68d1d.svg";